// @flow

export type VoucherAddMoneyActionType =
  | {|
      type: 'UPDATE_VOUCHER_CODE',
      payload: {| code: string | null |},
    |}
  | {|
      type: 'CLEAR_VOUCHER_DATA',
    |}
  | {|
      type: 'LEAVE_ADD_MONEY_SCENE',
    |}
  | {|
      type: 'REDEEM_VOUCHER',
      payload: {| customerOuid: string, voucherCode: string |},
    |}
  | {|
      type: 'FETCH_VOUCHER',
      payload: {| voucherCode: string |},
    |}
  | {|
      type: 'FETCH_VOUCHER_REQUEST',
    |}
  | {|
      type: 'FETCH_VOUCHER_FAILURE',
      error: any,
    |}
  | {|
      type: 'SET_VOUCHER',
      payload: {| voucher: Object |},
    |};

export const updateVoucherCode = (code: string | null): VoucherAddMoneyActionType => ({
  type: 'UPDATE_VOUCHER_CODE',
  payload: { code },
});

export const clearVoucherData = (): VoucherAddMoneyActionType => ({
  type: 'CLEAR_VOUCHER_DATA',
});

export const leaveAddMoneyScene = (): VoucherAddMoneyActionType => ({
  type: 'LEAVE_ADD_MONEY_SCENE',
});

export const redeemVoucher = (customerOuid: string, voucherCode: string): VoucherAddMoneyActionType => ({
  type: 'REDEEM_VOUCHER',
  payload: { customerOuid, voucherCode },
});

export const fetchVoucherRequest = (): VoucherAddMoneyActionType => ({
  type: 'FETCH_VOUCHER_REQUEST',
});

export const setVoucher = (voucher: Object): VoucherAddMoneyActionType => ({
  type: 'SET_VOUCHER',
  payload: { voucher },
});

export const fetchVoucherFailure = (error: any): VoucherAddMoneyActionType => ({
  type: 'FETCH_VOUCHER_FAILURE',
  error,
});

export const fetchVoucher = (voucherCode: string): VoucherAddMoneyActionType => ({
  type: 'FETCH_VOUCHER',
  payload: { voucherCode },
});
